<template>
    <div class="form-group">
        <input type="hidden" :id="name" :name="name" v-model="proxyValue"/>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        label: {
            Type: String,
        },
        name: {
            Type: String,
        },
        parentIndex: {
            Type: String,
        },
    },
    computed: {
        proxyValue: {
            get() { return this.value; },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
    },
    data() {
        return {
            value: null,
        };
    },
    mounted() {
        this.mountEvents();
    },
    methods: {
        mountEvents() {
            let eventManagerService = this.$root.getEventManager();
            this.$root.$on('FormComponent:show-component', () => {
                this.resetErrors();
            });
        },
        setValue(config, value) {
            this.value = value[this.name];
        },
    }
}

</script>


// WEBPACK FOOTER //
// HiddenInput.vue?651497c4